'use client';

import { Skeleton } from '@/components/Skeleton';
import { MediaType } from '@/helpers/enums';
import { useResponsive } from '@/modules/client';

const grid = {
  [MediaType.DESKTOP_L]: { cols: 6, rows: 1, size: 56 },
  [MediaType.DESKTOP]: { cols: 6, rows: 1, size: 56 },
  [MediaType.TABLET]: { cols: 4, rows: 1, size: 56 },
  [MediaType.MOBILE]: { cols: 3, rows: 1, size: 56 },
  [MediaType.MOBILE_S]: { cols: 2, rows: 1, size: 56 },
};

export function PaymentsSliderSkeleton() {
  const { currentMediaType } = useResponsive();
  const { cols, rows, size } = grid[currentMediaType];

  return (
    <div>
      {
        <Skeleton.Container
          gap={12}
          justifyContent="space-between"
          marginBottom={24}
        >
          <Skeleton.Rect height={40} width={250} />
          <Skeleton.Rect height={32} width={170} />
        </Skeleton.Container>
      }
      <Skeleton.Container
        display="grid"
        gap={16}
        gridTemplateColumns={`repeat(${cols}, 1fr)`}
        gridTemplateRows={`repeat(${rows}, 1fr)`}
      >
        {new Array(cols * rows).fill(0).map((_, i) => (
          <Skeleton.Rect height={size} key={i} />
        ))}
      </Skeleton.Container>
    </div>
  );
}
